/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrebidIntakeDto } from '../../models/prebid-intake-dto';

export interface GetAuctionPrebidIntake$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getAuctionPrebidIntake(http: HttpClient, rootUrl: string, params: GetAuctionPrebidIntake$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidIntakeDto>> {
  const rb = new RequestBuilder(rootUrl, getAuctionPrebidIntake.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidIntakeDto>;
    })
  );
}

getAuctionPrebidIntake.PATH = '/api/auctions/{id}/prebid-intake';
